export default {
  setPills(state, pills) {
    state.pills = pills;
  },
  increaseAmountOfCanistersByPillId(state, pillId) {
    state.pills = state.pills.map(p => {
      if (p.id === pillId) {
        p.amountOfCanisters += 1;
      }
      return p;
    });
  },
  decreaseAmountOfCanistersByPillId(state, pillId) {
    state.pills = state.pills.map(p => {
      if (p.id === pillId) {
        p.amountOfCanisters -= 1;
      }
      return p;
    });
  },
  setAmountOfCanistersByPillId(state, { pillId, value }) {
    state.pills = state.pills.map(p => {
      if (p.id === pillId) {
        p.amountOfCanisters = value;
      }
      return p;
    });
  }
};
